import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=e67d399c&"
import script from "./Loader.vue?vue&type=script&lang=js&"
export * from "./Loader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e67d399c')) {
      api.createRecord('e67d399c', component.options)
    } else {
      api.reload('e67d399c', component.options)
    }
    module.hot.accept("./Loader.vue?vue&type=template&id=e67d399c&", function () {
      api.rerender('e67d399c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/components/Loader.vue"
export default component.exports